import React, {useState, useEffect} from 'react';
import GTMDataLayer from './gtm';
import './scss/search.scss';

const FilterSearch = (props) => {

  const [isHidden, setIsHidden] = useState(true);

  // Set search count.
  const [searchCountCurrent, setSearchCountCurrent] = useState(1);
  const [searchCountTo, setSearchCountTo] = useState(1);
  const [searchButton, setSearchButton] = useState('');



  const setHiddenSate = () => {
    if (document.getElementById("searchInput").value.length > 0) {
      setIsHidden(false);
      document.getElementById("searchInput").removeAttribute('title');
    }
    else {
      setIsHidden(true);
    }

    if (document.getElementById("searchInput").value.length >= 3) {
      setSearchButton('enabled');
    }
  }

  useEffect(() => {
    setHiddenSate();
  }, [props.isReady]);

  useEffect(() => {
    if (props.pagination) {
      testSearchCount();
    }
  }, [props.pagination, searchCountCurrent]);

  const inputHandler = (e) => {
    e.preventDefault();
    const searchValue = document.getElementById("searchInput").value;
    if (searchValue.length >= 3) {
      props.setFilters({...props.filters, search: searchValue, page: 0});
      setIsHidden(false);

      // Track search with GTM.
      GTMDataLayer({
        event: 'index_app_filter_search',
        pageUrl: location.href,
        search_keyword: searchValue
      });
    }
    else if (searchValue.length < 3 && searchValue.length > 0) {
      props.setFilters({...props.filters, search: null});
      setIsHidden(false);
      document.getElementById("searchInput").setAttribute('title', Drupal.t('They keyword must be at least 3 characters long.'));
    }
    else if (searchValue.length == 0) {
      props.setFilters({...props.filters, search: null, page: 0});
      setIsHidden(true);
    }
  };

  const resetSearch = () => {
    if (document.getElementById("searchInput").value.length > 0) {
      document.getElementById("searchInput").value = '';
      props.setFilters({...props.filters, search: null, page: 0});
      setIsHidden(true);
      setSearchButton('');

      // Track clear search.
      GTMDataLayer({
        event: 'index_app_filter_clear',
        pageUrl: location.href,
        search_clear: 1
      });
    };
  };

  // Handle Clear search and tags link.
  const clearSearch = (e) => {
    e.preventDefault();
    document.getElementById("searchInput").value = '';
    setIsHidden(true);
    setSearchButton('');
    props.setFilters({...props.filters, search: null, page: 0});


    // Track reset.
    GTMDataLayer({
      event: 'index_app_filter_clear',
      pageUrl: location.href,
      filter_search_reset: 1
    });
  }
  
  // Count search display. 
  const testSearchCount = () => {
    if (props.pagination.page > 0) {
      setSearchCountCurrent(props.pagination.page * props.pagination.limit);
    }
    else {
      setSearchCountCurrent(1);
    }

    if ((props.pagination.total - searchCountCurrent) > props.pagination.limit) {
      if ((searchCountCurrent + props.pagination.limit) > props.pagination.total) {
        setSearchCountTo(props.pagination.total);
      }
      else {
        setSearchCountTo(searchCountCurrent + props.pagination.limit);
      }
    }
    else {
      setSearchCountTo(props.pagination.total);
    }
  }

  return (
    <>
    <form className='search-form  cp-search-bar--gray' onSubmit={inputHandler}>
        <input 
          id="searchInput" 
          type="text" 
          placeholder={`${Drupal.t('Search all')} ${props.searchFor}`}
          defaultValue={(props.filters.search) && props.filters.search}
          onChange={setHiddenSate}
          />
          <div id="resetSearch" className={isHidden ? 'hidden' : ''} onClick={resetSearch}>X</div>
        <button className={searchButton} type="submit">{Drupal.t('Search')}</button>
      </form>

      {(!props.loading && props.filters.search && props.filters.search.length > 0 && !props.loading && props.list.length != 0) && (
        <div className='search-result-count'>
          <span>{Drupal.t('Displaying')} {searchCountCurrent} - {searchCountTo} {Drupal.t('out of')} {props.pagination.total} {Drupal.t('results for')} "{props.filters.search}"</span> 
          <a href="#" onClick={clearSearch}>{Drupal.t('Clear search')}</a>.
        </div>
      )}
    </>
  );
};

export default FilterSearch;